import React, { ReactNode, createContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { CO2_LFL_SLUG, FAT_PROTEIN_SLUG, getFarmersFilterInputs, getFarmersFilters, MILK_FIXED_SLUG, MILK_MONEY_ACCOUNT_SLUG, MILK_STOCK_EXCHANGE } from '~/Constants';
import { useAuth } from '~/routes/components/AuthProvider';
import { filtersBasedOnModules } from './utils';

interface FilterInputValues {
  confirmedAmountFrom: string;
  confirmedAmountTo: string;
  yearlyAmountFrom: string;
  yearlyAmountTo: string;
}

interface FarmerContextType {
  search: string;
  filterInputValues: FilterInputValues;
  checkedFilters: any[];
}

interface FarmerContextValueType {
  contextValues: FarmerContextType
  setContextValues: (value: FarmerContextType) => void
}

const defaultContextValue = {
  search: '',
  filterInputValues: {
    confirmedAmountFrom: '',
    confirmedAmountTo: '',
    yearlyAmountFrom: '',
    yearlyAmountTo: ''
  },
  checkedFilters: []
}

export const FarmerContext = createContext<FarmerContextValueType>({
  contextValues: defaultContextValue,
  setContextValues: () => 1
})

interface FarmerContextProps {
  children: ReactNode
}

const tradingSlotSlugs = [MILK_FIXED_SLUG, MILK_STOCK_EXCHANGE, FAT_PROTEIN_SLUG]

const FarmerProviderComp: React.FC<FarmerContextProps> = (props) => {
  const { t } = useTranslation()
  const [contextValues, setContextValues] = useState<FarmerContextType>(defaultContextValue)
  const { systemData: { modules } } = useAuth()

  useEffect(() => {
    const filters = localStorage.getItem('farmersFilters')
    const farmersFilterInputs = getFarmersFilterInputs()
    const hasAnyTradingSlot = Boolean(modules.find(module => !!tradingSlotSlugs.find(tradingSlotSlug => tradingSlotSlug === module.slug)))
    const hasMilkMoneyModule = Boolean(modules.find(module => module.slug === MILK_MONEY_ACCOUNT_SLUG))
    const hasCo2Module = Boolean(modules.find(module => module.slug === CO2_LFL_SLUG))
    const farmersFilters = getFarmersFilters()
    if (filters) {
      const filtersParsed = filtersBasedOnModules(hasAnyTradingSlot, hasMilkMoneyModule, hasCo2Module, JSON.parse(filters))
      filtersParsed.forEach(filter => {
        const indexFilter = farmersFilters.findIndex(farmerFilter => farmerFilter.key === filter.key)
        if (indexFilter < 0) {
          const indexFilterInput = farmersFilterInputs.findIndex(farmerFilter => farmerFilter.key === filter.key)
          if (indexFilterInput >= 0) {
            filter.placeholder = farmersFilterInputs[indexFilterInput].placeholder
          }
        }
        if (filter?.options) {
          filter.options = farmersFilters[indexFilter].options
        }
      })
      setContextValues({
        ...contextValues,
        checkedFilters: filtersParsed
      })
    }
  }, [t])

  return <FarmerContext.Provider value={{ contextValues, setContextValues }}>
    {props.children}
  </FarmerContext.Provider>
}
export default FarmerProviderComp